import { getMessageCreationDate } from "../../Chat/helpers/getMessageCreationDate";

const getlastMessageDate = (timestamp) => {
  if(!timestamp) return '';
  return getMessageCreationDate(timestamp.toMillis());
}

export default getlastMessageDate;
